import { render, staticRenderFns } from "./ImageLibrary.vue?vue&type=template&id=0b8489e4&scoped=true&"
import script from "./ImageLibrary.vue?vue&type=script&lang=js&"
export * from "./ImageLibrary.vue?vue&type=script&lang=js&"
import style0 from "./ImageLibrary.vue?vue&type=style&index=0&id=0b8489e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8489e4",
  null
  
)

export default component.exports